<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <MessageViewOne :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @on-click-tab="onClickTab" />
    </div>
    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <MessageViewTwo :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @on-click-tab="onClickTab" />
    </div>
    <!-- Theme three -->
    <div v-if="themeStore.themeIndex === 3">
        <MessageViewThree :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @on-click-tab="onClickTab" />
    </div>
    <!-- Theme four -->
    <div v-if="themeStore.themeIndex === 4">
        <MessageViewFour :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @get-unread-msg-list="getUnreadMsgList" @on-click-tab="onClickTab" />
    </div> 
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { getMessageList, getUnreadMessageList, updateUnreadMessage } from '@/api/message';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import { restartSSE } from '@/utils/sse';
import { useI18n } from 'vue-i18n';
import MessageViewOne from '@/themes/themeOne/message/messageView.vue';
import MessageViewTwo from '@/themes/themeTwo/message/messageView.vue';
import MessageViewThree from '@/themes/themeThree/message/messageView.vue';
import MessageViewFour from '@/themes/themeFour/message/messageView.vue';
import { MessageItem, TabItem } from "@/view/message/supportScript";
import { TAB_LIST } from '@/view/message/supportScript';
import { PAGE_SIZE } from '../gameLog/supportScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const userStore = useUserStore()
const unReadMsgIds = computed(() => userStore.unreadMsgIdList)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()

// const active = ref(0);
const tabList = ref(TAB_LIST)
const totalMsg = ref(0)
const pageSize = ref(PAGE_SIZE)
const pageNo = ref(1)
const activeTab = ref<TabItem>({
    name: '',
    notice_type: 5,
    value: 0
})
const noticeList = ref<MessageItem[]>([])

const dataSet = computed(() => ({
    tabList: tabList.value,
    totalMsg: totalMsg.value,
    pageSize: pageSize.value,
    pageNo: pageNo.value,
    activeTab: activeTab.value,
    noticeList: noticeList.value
}))



const onClickTab = (value: any) => {
    activeTab.value = tabList.value.find(tab => tab.value === value.name) as TabItem
    noticeList.value = []
    totalMsg.value = 0
    pageSize.value = PAGE_SIZE
    pageNo.value = 1
    loadingRef.value.open()
    if (activeTab.value.notice_type == 5) {
        getUnreadMsgList()
    } else {
        getMsgList(activeTab.value.notice_type)
    }
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getMsgList = (value: number) => {
    let data = {
        type: value == 0 ? null : value,
        pageNum: pageNo.value,
        pageSize: pageSize.value
    }
    getMessageList(data).then(res => {
        loadingRef.value.close()
        if (res.data) {
            const combinedList = [...noticeList.value, ...res.data.rows];
            const uniqueList = Array.from(
                new Map(combinedList.map(item => [item.id, item])).values()
            );
            noticeList.value = uniqueList;
            totalMsg.value = res.data.total

            // System msg unread check and read
            if (value === 2) {
                const unreadSysMsg = combinedList.filter(item => item.status === 0)
                console.log('unreadSysmsg----', unreadSysMsg);
                setUnreadMsgIds()
            }
        } else {
            noticeList.value = []
        }
    }).catch(err => {
        showError(err)
        loadingRef.value.close()
        noticeList.value = []
    })
}

const setUnreadMsgIds = () => {
    const idList = noticeList.value
        .filter(item => item.status === 0)
        .map(item => item.id);
    if (idList.length > 0) {
        const newUnreadActivityMsgList = removeReadMessages(userStore.unreadActivityMsgList, idList)
        userStore.setActivityMsgList(newUnreadActivityMsgList)
        let data: any = {
            ids: idList
        }
        if (activeTab.value.notice_type == 1) {
            data.type = activeTab.value.notice_type
        }
        updateUnreadMessage(data).then(res => {
            const remainUnReadIds = unReadMsgIds.value.filter((item: any) => !idList.includes(item));
            userStore.setRemainUnreadMsgList(remainUnReadIds)
            restartSSE(process.env.VUE_APP_BASE_API + '/app/resource/sse')
        }).catch(err => {
            console.log("res", err);
        })
    }
}

const getNextPageMsgList = () => {
    if (activeTab.value.notice_type == 5) {
        if (totalMsg.value > noticeList.value.length) {
            getUnreadMsgList()
        }
    } else {
        if (totalMsg.value > pageSize.value * pageNo.value) {
            pageNo.value = pageNo.value + 1
            getMsgList(activeTab.value.notice_type)
        }
    }

}
const getUnreadMsgList = () => {
    let data = {
        pageSize: pageSize.value
    }
    getUnreadMessageList(data).then(res => {
        loadingRef.value.close()
        if (res.data) {
            const combinedList = [...noticeList.value, ...res.data.rows];
            const uniqueList = Array.from(
                new Map(combinedList.map(item => [item.id, item])).values()
            );
            noticeList.value = uniqueList;

            totalMsg.value = res.data.total
            setUnreadMsgIds()
        } else {
            noticeList.value = []
        }
    }).catch(err => {
        if (err.code != 401) {
            showError(err)
            loadingRef.value.close()
        }
        noticeList.value = []
    })
}

const removeReadMessages = (
    activityNotice: { id: number; msgList: number[] }[],
    readIdList: number[]
) => {
    return activityNotice.map(group => ({
        ...group,
        msgList: group.msgList.filter(msgId => !readIdList.includes(msgId))
    }));
}
onMounted(() => {
    if(themeStore.themeIndex !== 4){
      loadingRef.value.open()
       getUnreadMsgList()
    }   
})
</script>
